<template>
  <div class="lead-stage-preview">
    <template v-if="!!leadStage">
      <BLeadStageColorPreview
        size="small"
        :value="leadStage.colorName"
      />
      <span
        class="lead-name"
        :class="{'truncate-text': truncateText}"
      >{{ leadStage.name }}</span>
    </template>
    <span
      v-else
      class="placeholder"
      :class="{'truncate-text': truncateText}"
    >-</span>
  </div>
</template>

<script lang="ts" setup>
import { LeadStage } from '@/api/openapi';

export type TDisplayLeadStage = Pick<LeadStage, 'name' | 'colorName'>;
type TProps = {
  leadStage?: TDisplayLeadStage | null;
  truncateText?: boolean;
};

withDefaults(defineProps<TProps>(), {
  leadStage: null,
  truncateText: true,
});
</script>

<style lang="scss" scoped>
.lead-stage-preview {
  display: flex;
  align-items: center;

  .color-preview {
    margin-right: 8px;
  }
  .lead-name {
    flex: 1;
    min-width: 0;
  }
  .placeholder {
    color: $concrete-dark;
  }
}
</style>
